import {useContext} from "react";
import {TranslationContext} from "../context/LanguageContext";

const useTranslation = () => {
    const {translations, language, setLanguage, languages, rawTranslations} = useContext(TranslationContext);

    const t = (key) => {
        return translations?.[key] || key;
    };

    return {t, setLanguage, language, languages, translations, rawTranslations};
};

export default useTranslation;
